import text from '../../../../text.json'

export const formatPayer = (payer: string) => {
    const formattedPayer = text.payers[payer as keyof typeof text.payers]

    return formattedPayer ? formattedPayer : payer
}
